import React from 'react';
import { Box, Tooltip } from '@mui/material';

/**
 * A review cell's content, with its error or warning (from checkRows) shown on hover. The
 * cell's border and background colour come from the grid's cellClassName.
 */
export const ProblemTooltip = ({ row, field, children }) => (
	<Tooltip title={row.errors[field] ?? row.warnings[field] ?? ''} placement='top'>
		<Box sx={{ width: '100%', minHeight: '1.5em' }}>{children}</Box>
	</Tooltip>
);
